import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { useRouter } from "vue-router";
import { useMainStore } from "@/store/MainStore";
import FEATURE_FLAGS from "@/split-adapter/feature-flags";
import useFeatureFlagsStore from "@/store/feature-flags";

interface IMainNavigationOption {
  id: string;
  text: string;
  active: boolean;
  icon: string;
  path: string;
  forceNavigation: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarNavigation',
  setup(__props) {

//Imports
const PAYABLE_ROUTE = {
  id: "payables",
  text: "Payables",
  active: false,
  icon: "cash-solid",
  path: "/payables",
  forceNavigation: false,
};

const mainStore = useMainStore();
const featureFlagStore = useFeatureFlagsStore();
const isFeatureOn = computed(() => featureFlagStore.isOn(FEATURE_FLAGS.INTERNAL_ADMIN));

const router = useRouter();

const onNavigationUpdate = (event: CustomEvent) => {
  router.push(event.detail.path);
  mainStore.setCurrentSidebarOption(event.detail.id);
};

const NAVIGATION_OPTIONS: IMainNavigationOption[] = [
  {
    id: "stores",
    text: "Stores",
    active: mainStore.getCurrentSidebarOption === "stores",
    icon: "template-solid",
    path: "/",
    forceNavigation: false,
  },
  {
    id: "welcome",
    text: "Welcome",
    active: false,
    icon: "template-solid",
    path: "/welcome",
    forceNavigation: false,
  },
];
const getNavigationOptions = computed(() => {
  const currentSidebarOption = mainStore.getCurrentSidebarOption;
  const options = [...NAVIGATION_OPTIONS];
  isFeatureOn.value && options.push(PAYABLE_ROUTE);
  options.forEach((option) => {
    option.active = option.id === currentSidebarOption;
  });
  if (!mainStore.getAllStoreIds.length) {
    return options.filter((option) => option.id === "welcome");
  } else {
    return options.filter((option) => option.id !== "welcome");
  }
});

return (_ctx: any,_cache: any) => {
  const _component_snap_main_navigation = _resolveComponent("snap-main-navigation")!

  return (_openBlock(), _createBlock(_component_snap_main_navigation, {
    id: "main-navigation",
    ".navigationOptionsInput": getNavigationOptions.value,
    corner: "true",
    theme: "store",
    onNavigationupdate: _cache[0] || (_cache[0] = ($event: any) => (onNavigationUpdate($event)))
  }, null, 40, [".navigationOptionsInput"]))
}
}

})